/** Django appointment config URLs (until surfaced in SPA settings). */
export const APPOINTMENTS_CALENDAR_SETUP_PATH = '/appointments/config/setup'
export const APPOINTMENTS_CALENDAR_LIST_PATH = '/appointments/config/calendars/'
